module.exports = __webpack_public_path__ + "static/media/location-disclosure-map.6535bba0.png";